import { env } from '~constants/env';
import { LandingsStorage } from '~helpers/LandingsStorage';
import { StringUtils } from '~helpers/StringUtils';
import { Goals } from '~services/Goals';
import { LocalStorageKeys } from '~types/LocalStorage';

const goalsConfig = env.blogConfig?.goals;

function sendGoals() {
  Goals.gtag4(goalsConfig?.gtag ?? { event: 'sendform' });
  Goals.tmr(goalsConfig?.tmr ?? { goal: 'sendform_vkads' });
  Goals.ym(goalsConfig?.ym ?? { action: 'sales_send' });
}

function utmToString(data: Record<string, string>) {
  const arr = Object.entries(data).reduce((result, [key, value]) => {
    result.push(`${key}=[${value}]`);

    return result;
  }, [] as string[]);

  return arr.join(' ');
}

function getComment({
  comment = '',
  formLabel = '',
  extraFields = [],
}: {
  comment?: string;
  extraFields?: Array<{
    name: string;
    value: string;
  }>;
  formLabel?: string;
}) {
  const { host, pathname } = window.location;
  const enterPageData = LandingsStorage.get(LocalStorageKeys.LandingsEntryPage);
  const utmData = LandingsStorage.get(LocalStorageKeys.LandingsUtmData);
  const data: Array<string> = [];

  if (formLabel) {
    data.push(`label=[${formLabel}]`);
  }

  data.push(`url=[${host}${pathname}]`);

  data.push(comment);

  extraFields?.forEach((field) => {
    data.push(`${field.name}=[${field.value}]`);
  });

  if (enterPageData) {
    data.push(`entry_page=[${enterPageData.pathname}]`);
    const utmEnterPage = enterPageData.utm && utmToString(enterPageData.utm);

    if (utmEnterPage) {
      data.push(utmEnterPage);
    }
  }

  if (utmData) {
    const utmLastClick = utmToString(utmData);

    data.push('last click:');
    data.push(utmLastClick);
  }

  return StringUtils.replaceLineBreak(data.join(' '), ' '); // бэк не может переносы
}

export const SalesUtils = { sendGoals, getComment };
